export enum DndTypes {
  Course = 'course',
  Module = 'module',
  AudioAsset = 'audioAsset',
}
